import type { ImageWidget } from "~/types/widgets";
import Image from "~/components/ui/Image";
interface Props {
  logos?: Logo[];
}

export interface Logo {
  image: ImageWidget;
  alt?: string;
  href?: string;
  width?: number;
  height?: number;
}

function Logos({ logos }: Props) {
  return (
    <div className="flex justify-center items-center">
      {logos && logos?.length
        ? (
          <ul className="flex gap-[45px] my-5">
            {logos.map((logo) => (
              <li className="flex items-center justify-center">
                {logo.href
                  ? (
                    <a href={logo.href}>
                      <Image
                        loading="lazy"
                        fetchPriority="low"
                        className="min-w-[70px] grayscale brightness-0"
                        width={logo.width ?? 70}
                        height={logo.height ?? 30}
                        src={logo.image}
                        alt={logo.alt}
                      />
                    </a>
                  )
                  : (
                    <Image
                      loading="lazy"
                      fetchPriority="low"
                      className="min-w-[70px] grayscale brightness-0"
                      width={logo.width ?? 70}
                      height={logo.height ?? 30}
                      src={logo.image}
                      alt={logo.alt}
                    />
                  )}
              </li>
            ))}
          </ul>
        )
        : <></>}
    </div>
  );
}

export default Logos;
